module.exports = __webpack_public_path__ + "media/images/application/template/flag-uk-c58e149f9d6ba36cf72e2725e8fa3f95.png";